import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {BoxScoresWidgetFetchHandler} from "./box-scores-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {BoxScoresWidgetTabClickHandler} from "./box-scores-widget.tab-click.handler";
import {BoxScoresWidgetAllStatsClickHandler} from "./box-scores-widget.all-stats-click.handler";
import {BoxScoresWidgetLineupsToggleClickAnalyticsEventHandler} from "./box-scores-widget.lineups-toggle-click.analytics-event.handler";
import {BoxScoresWidgetDisplayAnalyticsEventHandler} from "./box-scores-widget.display.analytics-event-handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {LineupsWidgetPlayerCardPopupClickHandler} from "../../lineups-widget/handlers/lineups-widget.player-card-popup-click.handler";
import {FullGamePopulateDataHandler} from "../../../core/handlers/full-game.populate-data.handler";

export class BoxScoresWidgetHandlers extends HandlerList {

  static injectables = [
    BoxScoresWidgetFetchHandler,
    BoxScoresWidgetTabClickHandler,
    BoxScoresWidgetAllStatsClickHandler,
    BoxScoresWidgetLineupsToggleClickAnalyticsEventHandler,
    BoxScoresWidgetDisplayAnalyticsEventHandler,
    LineupsWidgetPlayerCardPopupClickHandler,
    EntityClickEventHandler,
    TimingHandler,
    FullGamePopulateDataHandler
  ];

  constructor(
    boxScoresWidgetFetchHandler: BoxScoresWidgetFetchHandler,
    boxScoresWidgetTabClickHandler: BoxScoresWidgetTabClickHandler,
    boxScoresWidgetAllStatsClickHandler: BoxScoresWidgetAllStatsClickHandler,
    boxScoresWidgetLineupsToggleClickAnalyticsEventHandler: BoxScoresWidgetLineupsToggleClickAnalyticsEventHandler,
    boxScoresWidgetDisplayAnalyticsEventHandler: BoxScoresWidgetDisplayAnalyticsEventHandler,
    lineupsWidgetPlayerCardPopupClickHandler: LineupsWidgetPlayerCardPopupClickHandler,
    entityClickEventHandler: EntityClickEventHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: FullGamePopulateDataHandler
  ) {
    super();

    [
      boxScoresWidgetFetchHandler,
      boxScoresWidgetTabClickHandler,
      boxScoresWidgetAllStatsClickHandler,
      boxScoresWidgetLineupsToggleClickAnalyticsEventHandler,
      boxScoresWidgetDisplayAnalyticsEventHandler,
      lineupsWidgetPlayerCardPopupClickHandler,
      entityClickEventHandler,
      timingHandler,
      fullGamePopulateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
